<template>
    <div :class="isEM ?　'main_container em' : 'main_container'">
        <div class="detail_container invoice_detail" v-loading="detailLoading">
            <ul class="invoice_lists">
                <li :key="index" class="invoice_list"
                    v-for="(invoice, index) in myInvoice.invoiceLists">
                    <div class="invoice_tag">
                        <el-tag :style="{backgroundColor: myInvoice.invoiceStatusColorRGBA, borderColor: '#' + myInvoice.invoiceStatusColor, color: '#' + myInvoice.invoiceStatusColor}"
                                v-if="invoice.invoiceStatus !== ''">
                            {{invoice.invoiceStatus.Value}}
                        </el-tag>
                        <el-tag type="warning" v-if="invoice.invoiceForm.changeFields.length > 0">
                            {{$t('message.Modified')}}
                        </el-tag>
                        <el-tooltip :content="invoice.invoiceForm.ReasonDetail" class="item" effect="dark" placement="top">
                            <span>
                                <i class="iconfont icon-zhushi-kong" v-if="invoice.invoiceForm.IsDisplayReason == 1"></i>
                            </span>
                        </el-tooltip>
                    </div>
                    <div class="invoice_form">
                        <invoice-edit :curItem="0" :invoiceData="invoice.invoiceForm"></invoice-edit>
                    </div>
                </li>
            </ul>
        </div>
        <div class="invoice_back" v-if="!isEM">
            <el-tooltip :content="$t('message.Back')" class="item" effect="dark" placement="top">
                <el-button
                        @click="goBack"
                        class="iconfont icon-zuo"
                        type="primary"
                ></el-button>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
    import {GetInvoiceDetail} from "../api/apiInvoice";
    import {getLocal, colorRGBA} from "../config/mUtils";
    import {pdfPath} from "../config/env";
    import InvoiceEdit from "../components/invoiceEdit";

    export default {
        name: 'retrievalDetail',
        components: {InvoiceEdit},
        data() {
            return {
                pdfPath,
                detailLoading: false,
                InvoiceDetailId: '',
                curIndex: -1,
                myInvoice: {
                    invoiceStatusColor: '',
                    invoiceStatusColorRGBA: '',
                    totalInvoice: '',
                    invoiceLists: [],
                    changedInvoice: 0
                },
                isEM: false
            }
        },
        props: ['DetailId'],
        created() {
            this.getLanguageResourceForPage();
            if (this.$route.query.Id) {
                this.InvoiceDetailId = this.$route.query.Id;
                this.getInvoiceDetail();
            } else if (this.$route.query.InvoiceKey) {
                this.InvoiceDetailId = this.DetailId;
                this.getInvoiceDetail();
                this.isEM = true;
            } else {
                this.curIndex = -1;
                this.getOCRData();
            }
        },
        mounted() {
        },
        computed: {},
        watch: {},
        methods: {
            // 获取发票明细
            async getInvoiceDetail() {
                this.detailLoading = true;
                try {
                    let data = await GetInvoiceDetail(
                        this.InvoiceDetailId,
                        getLocal('language')
                    );
                    if (data.error_code === '0') {
                        this.detailLoading = false;
                        this.myInvoice.invoiceStatusColor = data.data.invoiceStatusColor;
                        this.myInvoice.invoiceStatusColorRGBA = colorRGBA(data.data.invoiceStatusColor);
                        this.myInvoice.totalInvoice = '一';
                        this.myInvoice.invoiceLists[0] = {
                            invoiceInfo: {},
                            invoiceStatus: data.data.invoiceStatus,
                            verifiedResult: data.data.verifiedResult,
                            invoiceForm: {
                                Id: this.InvoiceDetailId,
                                remark: data.data.invoiceRemarks,
                                formMap: data.data.main,
                                fileInfo: data.data.fileInfo,
                                changeItems: data.data.changeItems,
                                invoiceItem: data.data.invoiceItem,
                                changeFields: data.data.changeFields,
                                errorFields: data.data.errorFieldsNew,
                                typeDesc: data.data.typeDesc,
                                IsDisplayReason: data.data.IsDisplayReason,
                                ReasonContent: data.data.ReasonContent,
                                ReasonDetail: data.data.ReasonDetail,
                                invoiceDetailTitle: data.data.invoiceDetailTitle
                            }
                        }
                        if (data.data.fileInfo.FileType.toLocaleLowerCase() === '.pdf') {
                            this.myInvoice.invoiceLists[0].invoiceForm.fileInfo.PDFUrl = pdfPath + '?file=' + encodeURIComponent(data.data.fileInfo.FileUrl);
                        }
                    } else {
                        this.$message.error(data.message);
                        setTimeout(() => {
                            this.detailLoading = false;
                            this.$router.push('/retrieval');
                        }, 1000);
                    }
                } catch (error) {
                    this.detailLoading = false;
                    console.log(error);
                }
            },
            // 返回首页
            goBack() {
                this.$router.push('/retrieval');
            }
        }
    }
</script>

<style scoped>
    .main_container {
        -moz-overflow: visible;
        -ms-overflow: visible;
        overflow: visible;
        overflow: initial;
    }
</style>
